<template>
  
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})" style="cursor: pointer;">首页</a-breadcrumb-item>
      <a-breadcrumb-item>知识产权需求</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="cont_body">
    <div class="body_img">
      <img src="../../../img/jyxq.jpg" />
    </div>
    <div class="body_cont">
    <div v-for="(item,key) in dataSource" :key="key" @click="goMore('/knowledge/need/page','知识产权需求',item.id)" class="list_cont">
      <div class="img_cont">
        <div class="img">
          <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
          <img v-else src="@/assets/img/defaultPhoto.png" alt="">
        </div>
        <div class="img_right">
          <h3>{{item.needName}}</h3>
          <p class="text" v-html="item.needBody"></p>
        </div>
      </div>
      <!-- <div class="list_cont_body">
        <h4>{{ item.needName }}</h4>
        <h5>需求方：{{ item.thumbnail}}</h5>
        <P>需求类型：
          {{ item.content}}
        </P>
      </div> -->
    </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import { 
  // dictMixin,
  listMixin } from "@/mixins";
import {basicsNeedInfo} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
// import DictRender from "@/components/other/DictRender";
// import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { 
    // DictRender
   },
  mixins: [
    // dictMixin,  
  listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // financeDict,
      options:null,
      dictNames: 'demand_type',
      listUrl: basicsNeedInfo.pageList,
      queryParamFixed: { 
              needType: this.demand_types,
              moduleType: '5',
              systemType: 'knowledge'
       },
      current: 1,
      pageSize: 10,
    }
  },
  mounted() {
      this.getDict();
  },
	methods: {
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "demand_type"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/knowledge/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 492px;
  margin-bottom: 16px;
  margin-right: 16px;
  &:nth-child(2n){
    margin-right: 0;
  }
  .img_cont{
    display: flex;
    padding:19px 20px;
    width: 100%;
    .img{
      width:100px;
      margin-right:20px;
      img{
        width:100%
      }
    }
    .img_right{
      flex: 1;
      p{
        color:#cccccc;
        text-align: left;
        word-break: break-all;
        overflow:hidden; 
        text-overflow:ellipsis; 
        display:-webkit-box;
        -webkit-box-orient:vertical;  
        -webkit-line-clamp:3;
      }
    }
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    flex: 1;
    display: flex;
    align-items: center;
    img{
      width:100%
    }
  }
  .list_cont_body{
    padding:20px;
    flex: 5;
  }
}
</style>